export const LANGFUSE_SYSTEM_TAG = 'system';

export const SYSTEM_PROMPT_ANONYMIZED_CONSIDERATIONS = 'SYSTEM_anonymized_considerations';
export const SYSTEM_PROMPT_CHANGE_LANGUAGE = 'SYSTEM_change_language';
export const SYSTEM_PROMPT_DETAILED_REPORT_INSTRUCTIONS = 'SYSTEM_detailed_report_instructions';
export const SYSTEM_PROMPT_SUGGESTED_PROMPTS = 'SYSTEM_suggested_prompt';
/** Starter prompts of the IQ Boost v2 all-households dialog; same config shape as `SYSTEM_suggested_prompt`. */
export const SYSTEM_PROMPT_SUGGESTED_PROMPTS_ALL_HOUSEHOLDS = 'SYSTEM_suggested_prompt_all_household';

export enum SystemType {
  ANONYMIZED_CONSIDERATIONS = 'anonymized-considerations',
  SUGGESTED_PROMPTS = 'suggested-prompts',
  CHANGE_LANGUAGE = 'change-language',
}
